import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';

export default function NotFound() {
  return (
    <Layout>
      <section className="min-h-[70vh] flex items-center">
        <div className="max-w-container mx-auto px-5 md:px-12 text-center">
          <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-care">404</div>
          <h1 className="mt-3 text-[40px] md:text-[56px] font-medium text-ink">This page wandered off.</h1>
          <p className="mt-4 text-[17px] text-muted">Let's get you back on track.</p>
          <Link to="/" className="mt-8 inline-flex items-center gap-2 h-[50px] px-7 rounded-[14px] bg-care text-white font-semibold cursor-pointer whitespace-nowrap hover:bg-careDark">
            Back to Home <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>
    </Layout>
  );
}